import BackgroundImages from '../assets/img/bg/background images.png';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './Authform.css'
import  { useHistory } from  'react-router-dom'
import  axios from '../axios'
import { useStateValue } from '../StateProvider';

import logoss from '../assets/img/lodjdjd.png'
function AuthForm({}) {
   const history = useHistory()
   const [username, setusername] = useState('')
   const [password, setpassword] = useState('')
   const [userdata, setuserdata] = useState([])
   const [userinfo, setuserinfo] = useState({})
   const [open ,setopen] = useState(false)
   const[user, dispatch] = useStateValue();
  const [open1, setopen1] = useState(false)

   const login  = async e => {
    e.preventDefault();
   const logidata =  await axios.instance.post('/login', {
    User_Code: username,
    Password:  password
   }).then(res => {
       if(Object.keys(res.data).length === 2){
        localStorage.setItem('user', JSON.stringify(res.data))
       
        setuserdata(res.data.eventlist)
        localStorage.setItem('authtoken', 'Bearer '+res.data.token)
        for(const data2 of res.data.getlogin) {
          localStorage.setItem('AuthUser','true')
          localStorage.setItem('Usercode', data2.UserCode )
          localStorage.setItem('Username', data2.UserName)
          localStorage.setItem('Userid', data2.UserId)
          localStorage.setItem('Special_User', data2.Special_User)
          localStorage.setItem('Customer_Log', data2.Customer_Log)
          localStorage.setItem('CustomerName', data2.CustomerName)
          localStorage.setItem('Branch_Log', data2.Branch_Log)
          localStorage.setItem('BranchName', data2.BranchName)
          localStorage.setItem('AdminUser',data2.AdminUser)
          
          localStorage.setItem('approvereq',data2.ApprovalReq )
         
        }
       }
       
      dispatch({
        type:"SET_USER",
       user: res.data
      })
    
      if(Object.keys(res.data).length === 2 ){
      history.push('/Dashboard')
    }else {
     
      setopen(true)
    }
    setTimeout(() => {
      setopen(false)
    }, 2000);
    
     
   })

   }

   useEffect(() => {
    localStorage.setItem('cateid', 0)
    localStorage.setItem('AuthUser','false')
   }, [])


const changepss = () => {
  
    history.push('/changepassowrd')
 
 
}

  return (
    <div>
       <div className='imgaesty'>
      <img src={logoss}     />
      <p style={{color:'#7b3772', textAlign:'center'}}><b>Order online for your office needs</b></p>
  
 

      </div>
      
       <div className="authpage">
        <div className="cardlogin">
       
      <Form onSubmit={login} >
      
          {/* <div className="text-center pb-4">
<p>
          </div> */}
      
        <FormGroup>
          <Label >User code</Label>
          <Input  value={username} placeholder="User code"  onChange={e => setusername(e.target.value)}  />
          {open ? <p className="errors">invalid usercode</p> : ''}
        </FormGroup>
        <FormGroup>
          <Label >Password</Label>
          <Input type="password" value={password} placeholder="password"  onChange={e => setpassword(e.target.value)}/>
          {open ? <p className="errors">invalid password </p> : ''  }
        </FormGroup>
        <FormGroup>
    <p style={{color:'red', marginLeft:220, alignSelf:'flex-end', justifyContent:'flex-end', cursor:'pointer'}} onClick={changepss}>Change Password ?</p>
    </FormGroup>
        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
         
         >
       Login
        </Button>
      
        {/* {userdata.length !=0 ?  userdata.map((data2) => (
           localStorage.setItem('Usercode', data2.UserCode ),
           localStorage.setItem('Username', data2.UserName),
           localStorage.setItem('Userid', data2.UserId),
            localStorage.setItem('Special_User', data2.Special_User),
            localStorage.setItem('Customer_Log', data2.Customer_Log),
            localStorage.setItem('CustomerName', data2.CustomerName),
            localStorage.setItem('Branch_Log', data2.Branch_Log),
            localStorage.setItem('BranchName', data2.BranchName),
            localStorage.setItem('AdminUser',data2.AdminUser)
             
  )): ''} */}
         
      </Form>
      </div>
      </div>
    
    </div>
  )
}
export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  onLogoClick: () => {},
};
export default AuthForm
